import { combineReducers } from "redux";

const rootReducer = combineReducers({
  // add your reducers here
});

export default rootReducer;
